<template>
    <div v-if="mediaObject" v-b-tooltip :title="getTitle">
        <b-progress v-if="progress < 100 && mediaObject.encoderTasks.length" :value="progress" variant="primary" :max="100" show-progress animated></b-progress>
        <b-btn-group v-else>
            <b-btn tag="a" :href="mediaObject.thumbs.cover" target="_blank" size="sm" variant="secondary">
                <i class="fa fa-image"></i> img
            </b-btn>
            <b-btn tag="a" :href="mediaObject.thumbs['360p']" target="_blank" size="sm" variant="primary">
                <i class="fa fa-video-camera"></i> 360p
            </b-btn>
            <b-btn tag="a" :href="mediaObject.thumbs['480p']" target="_blank" size="sm" variant="primary">
                <i class="fa fa-video-camera"></i> 480p
            </b-btn>
            <b-btn tag="a" :href="mediaObject.thumbs['720p']" target="_blank" size="sm" variant="primary">
                <i class="fa fa-video-camera"></i> 720p
            </b-btn>
        </b-btn-group>
    </div>
</template>

<script>
    import ApiCacheMixin from '../mixin/ApiCacheMixin';

    const activeTimers = new Map();
    
    export default {
        name: "EncoderProcess",
        mixins: [ApiCacheMixin],
        props: ['media'],
        data() {
          return {
              progress: 0,
              timer: null,
              data: null,
              loading: false,
              mediaObject: null,
              debounceTimer: null
          }
        },
        mounted() {
            if(this.media) {
                this.loadMediaObject();
            }
        },
        methods: {
            async loadMediaObject() {
                const mediaId = this.media.id;
                
                try {
                    // Используем кэшированный запрос
                    const data = await this.getCachedMediaObject(mediaId);
                    this.mediaObject = data;
                    this.data = this.media;
                    
                    if (data.encoderTasks && data.encoderTasks.length) {
                        this.calculateProgress();
                        this.startPolling();
                    }
                } catch (error) {
                    console.error('Error loading media object:', error);
                }
            },
            
            startPolling() {
                const mediaId = this.media.id;
                
                // Если уже есть активный таймер для этого media_id, не создаем новый
                if (activeTimers.has(mediaId)) {
                    return;
                }
                
                this.timer = setInterval(() => {
                    this.fetchEventsList();
                }, 10000);
                
                activeTimers.set(mediaId, this.timer);
            },
            
            calculateProgress() {
                if (!this.data || !this.data.encoderTasks) return;
                
                let count = this.data.encoderTasks.length;
                let progress = 0;
                
                this.data.encoderTasks.forEach(task => {
                    progress += task.progress;
                });
                
                this.progress = count ? Math.ceil(progress / count) : 0;
            },
            
            getTitle() {
                if(this.progress > 0 && this.progress < 100) {
                    return 'В процессе'
                }
                if(this.progress === 100) {
                    return 'Завершено'
                }
                return 'В очереди'
            },
            
            async fetchEventsList() {
                if (!this.data) return;
                
                // Дебаунсинг запросов
                if (this.debounceTimer) {
                    clearTimeout(this.debounceTimer);
                }
                
                this.debounceTimer = setTimeout(async () => {
                    try {
                        // Инвалидируем кэш и получаем свежие данные
                        this.invalidateMediaObjectCache(this.data.id);
                        const data = await this.getCachedMediaObject(this.data.id);
                        
                        this.data = data;
                        this.mediaObject = data;
                        
                        this.calculateProgress();
                        
                        if (this.progress === 100) {
                            this.cancelAutoUpdate();
                        }
                    } catch (error) {
                        console.error('Error fetching media object updates:', error);
                    }
                }, 1000); // Дебаунсинг на 1 секунду
            },
            
            cancelAutoUpdate() {
                if (this.timer) {
                    clearInterval(this.timer);
                    activeTimers.delete(this.media.id);
                    this.timer = null;
                }
            }
        },
        
        beforeDestroy() {
            this.cancelAutoUpdate();
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }
        }
    }
</script>

<style scoped>

</style>
